import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Route, UrlSegment, Router } from "@angular/router";
import { Auth0AuthorizationService } from "@mrdm-self-service-frontend/shared/util-authorization";
import { Observable } from "rxjs";
import { tap, take, map } from "rxjs/operators";

export const LOCAL_STORAGE_LOGOUT_URL_KEY = "self-service-logout-url";

@Injectable({
    providedIn: "root",
})
export class PublicPagesGuard
    
{
    private _auth = inject(Auth0AuthorizationService);
    private _router = inject(Router);


    canActivate(
        _next: ActivatedRouteSnapshot,
        _state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean | UrlTree> | boolean {
        return this._auth.isAuthenticated$.pipe(
            take(1),
            tap((loggedIn) => {
                if (loggedIn) {
                    this._setLogoutUrl(_state.url);
                    this._router.navigate(["logged-in"]);
                }
            }),
            map((loggedIn) => !loggedIn)
        );
    }

    canActivateChild(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean | UrlTree> | boolean {
        return this.canActivate(next, state);
    }

    canLoad(
        _route: Route,
        segments: UrlSegment[]
    ): Observable<boolean> | Promise<boolean> | boolean {
        return this._auth.isAuthenticated$.pipe(
            take(1),
            tap((loggedIn) => {
                if (loggedIn) {
                    const logoutReturnUrl = segments.reduce(
                        (path, currentSegment) => {
                            return `${path}/${currentSegment.path}`;
                        },
                        ""
                    );
                    this._setLogoutUrl(logoutReturnUrl);
                    this._router.navigate(["logged-in"]);
                }
            }),
            map((loggedIn) => !loggedIn)
        );
    }

    private _setLogoutUrl(logoutReturnUrl: string): void {
        localStorage.setItem(LOCAL_STORAGE_LOGOUT_URL_KEY, logoutReturnUrl);
    }
}
